
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/today-gift/[[...pathParams]]",
      function () {
        return require("private-next-pages/today-gift/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/today-gift/[[...pathParams]]"])
      });
    }
  